import { Component, inject } from '@angular/core';
import { CartReconciliationService } from '../../../core/services/cart-reconciliation.service';

@Component({
  selector: 'app-cart-update-notice',
  templateUrl: './cart-update-notice.html',
  styleUrl: './cart-update-notice.scss'
})
export class CartUpdateNotice {
  private readonly reconciliation = inject(CartReconciliationService);

  readonly notice = this.reconciliation.notice;

  dismiss(): void {
    this.reconciliation.dismiss();
  }
}
